import { differenceInDays } from 'date-fns';

import {
    EventResult,
    FocusContainerDto,
    InteractionDto,
    ObservationDto,
} from '../../../../../coaching-base/general';
import { NoteDetailFormValue } from '../../../../../coaching-note/note-detail-form-value.model';
import { Chat, ChatMessage } from '../../../../../teams-call';
import { BehaviourTag } from '../../../../transcript-dialog/model/behaviour-tag.model';

export function createObservationOverride(
    chat: Chat,
    messages: ChatMessage[],
    focus: BehaviourTag,
    notes: NoteDetailFormValue[],
): ObservationDto {
    // check if transcript is over 30 days
    const now = new Date();
    const createdOn = new Date(chat.createdOn);
    const days = differenceInDays(createdOn, now);
    const obsStartDate = 30 + days < 0 ? now : createdOn;

    const interaction: InteractionDto = {
        createdBy: undefined,
        createdOn: undefined,
        interactionDateTime: obsStartDate,
        interactionId: undefined,
        interactionIdentifier: undefined,
        interactionTypeId: undefined,
        interactionPurposeId: undefined,
        notes: notes.map((e) => ({
            noteId: e.noteId,
            noteCategoryId: e.category,
            contents: e.contents,
            createdBy: undefined,
            createdOn: undefined,
            published: undefined,
            publishedOn: undefined,
        })),
        observerId: undefined,
        performerId: undefined,
        queueId: undefined,
        scoring: undefined,
        updatedBy: undefined,
        updatedOn: undefined,
    };

    // const transcriptFocus = focus;
    const fc: FocusContainerDto = {
        behaviourId: focus?.behaviour?.id ?? 0,
        focusId: 0,
        interactions: [interaction],
        metrics: [],
        subBehaviourId: focus?.subBehaviour?.id ?? 0,
    };

    const event: EventResult = {
        createdBy: undefined,
        createdOn: undefined,
        deleted: undefined,
        deliveryTypeFullName: undefined,
        deliveryTypeId: undefined,
        deliveryTypeInitials: undefined,
        deliveryTypeShortName: undefined,
        duration: Math.max(
            1,
            Math.ceil(
                (messages?.at(-1)?.endTime?.getTime() ??
                    0 - (messages?.at(0)?.endTime?.getTime() ?? 0)) /
                    1000 /
                    60,
            ),
        ),
        endTime: undefined,
        eventId: undefined,
        eventTypeFullName: undefined,
        eventTypeId: undefined,
        eventTypeInitials: undefined,
        eventTypeShortName: undefined,
        published: undefined,
        sessionDate: undefined,
        shareWithPerformer: undefined,
        startTime: obsStartDate,
        updatedBy: undefined,
        updatedOn: undefined,
    };

    return {
        event,
        eventParticipants: [],
        focusContainers: [fc],
    };
}
